import React from 'react'
import { useDispatch } from 'react-redux'

import { AnswerBlock, AnswerText } from '../common'
import { answerQuestionSingle } from '../../../redux/slices/questionsSlice'
import { types } from '../../../redux/initialStates/questions/questionType'

import './styles.scss'

const TextAnswers = ({ question, nextQuestion }) => {
	const dispatch = useDispatch()

	const onSelectAnswer = (questionId, answerIdx) => {
		dispatch(answerQuestionSingle({ questionId, answerIdx }))
		nextQuestion()
	}

	const answerController = () => {
		switch (question.componentType) {
			case types.TEXT_ANSWERS: {
				return (
					<>
						{question.answers.map((answer, answerIdx) => (
							<AnswerBlock
								key={answer.answer + answer.emoji}
								onSelectAnswer={() => onSelectAnswer(question.id, answerIdx)}
								{...answer}
							/>
						))}
					</>
				)
			}
			case types.WITHOUT_EMOJI_TEXT_ANSWERS: {
				return (
					<>
						{question.answers.map((answer, answerIdx) => (
							<AnswerText
								key={answer + answerIdx}
								onSelectAnswer={() => onSelectAnswer(question.id, answerIdx)}
								answer={answer}
							/>
						))}
					</>
				)
			}
			default: {
				return <p>Component not found</p>
			}
		}
	}

	return <>{answerController()}</>
}
export { TextAnswers }
